const initialState = {
  loading: false,
  carecells: [],
  error: null,
  saving: false,
  selectedCarecell: null,
};

const carecellsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_CARECELLS_REQUEST":
      return { ...state, loading: true, error: null };

    case "FETCH_CARECELLS_SUCCESS":
      return { ...state, loading: false, carecells: action.payload || [] };

    case "FETCH_CARECELLS_FAILURE":
      return { ...state, loading: false, error: action.payload };

    case "SAVE_CARECELL_SUCCESS":
        return {
            ...state,
            carecells: [...(state.carecells || []), action.payload],
          };

          case "DELETE_CARECELL_SUCCESS":
            return {
              ...state,
              carecells: state.carecells.filter(
                (c) => c.carecellObjId !== action.payload.carecellObjId
              ),
            };
          

    case "UPDATE_CARECELL_SUCCESS":
      return {
        ...state,
        carecells: state.carecells.map((c) =>
          c._id === action.payload._id ? action.payload : c
        ),
      };

    case "FETCH_CARECELL_BY_ID_SUCCESS":
      return { ...state, selectedCarecell: action.payload };

    default:
      return state;
  }
};

export default carecellsReducer;
